import { render, staticRenderFns } from "./Informativa-sui-cookie.vue?vue&type=template&id=17c336f1&scoped=true&"
import script from "./Informativa-sui-cookie.vue?vue&type=script&lang=js&"
export * from "./Informativa-sui-cookie.vue?vue&type=script&lang=js&"
import style0 from "./Informativa-sui-cookie.vue?vue&type=style&index=0&id=17c336f1&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c336f1",
  null
  
)

export default component.exports